import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveTechnologies,
  createTechnology,
  deleteTechnologies,
  getAllActiveTechnologies,
  getAllTechnologies,
  getTechnologiesByID,
  updateTechnologies,
  TechnologyDetailsImageUpload,
} from "./services/technology.service";
import { ITechnologies, ITechnologiess } from "./technologyModal";

const initialState: ITechnologiess = {
  loading: false,
  formloading: false,
  error: "",
  TechnologyID: null,
  TechnologiesList: [],
  TechnologyDetail: {
    ID: null,
    Title: "",
    Description: "",
    IsActive: 1,
  },
};

const technologySlice = createSlice({
  name: "technology",
  initialState,
  reducers: {
    clearTechnologyDetails: (state) => {
      state.TechnologyDetail = initialState.TechnologyDetail;
    },
    setTechnologyID: (state, action) => {
      state.TechnologyID = action.payload;
    },
    clearTechnologyID: (state) => {
      state.TechnologyID = initialState.TechnologyID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTechnologies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTechnologies.fulfilled,
      (state, action: PayloadAction<ITechnologies[]>) => {
        state.loading = false;
        state.TechnologiesList = action.payload || [];
      }
    );
    builder.addCase(getAllTechnologies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TechnologiesList = [];
    });
    builder.addCase(createTechnology.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createTechnology.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createTechnology.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTechnologies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTechnologies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateTechnologies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTechnologies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTechnologies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTechnologies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTechnologiesByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getTechnologiesByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.TechnologyDetail = action.payload;
    });
    builder.addCase(getTechnologiesByID.rejected, (state, action) => {
      state.loading = false;
      state.TechnologyDetail = initialState.TechnologyDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTechnologies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTechnologies.fulfilled,
      (state, action: PayloadAction<ITechnologies[]>) => {
        state.loading = false;
        state.TechnologiesList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTechnologies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TechnologiesList = [];
    });
    builder.addCase(ActiveInactiveTechnologies.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTechnologies.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTechnologies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(TechnologyDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(TechnologyDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(TechnologyDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTechnologyDetails, clearTechnologyID, setTechnologyID } =
  technologySlice.actions;
export default technologySlice.reducer;
